import { isEmpty } from 'bold-ui'
import { SimNaoEnum } from 'components/form'

import { PassouFalhouEnum } from '../../model-consultaSeguimento'
import { hasAnySim, isAllNao } from '../../utils-consultaSeguimento'
import {
  ConsultaSeguimentoPergunta07ApontaPorEnum,
  ConsultaSeguimentoPergunta07Model,
  ConsultaSeguimentoPergunta07OlharParaEnum,
} from './model-consultaSeguimentoPergunta07'

const pergunta07OlharParaEnumValues = Object.values(ConsultaSeguimentoPergunta07OlharParaEnum)

export const isPergunta07OlharParaAllNao = (
  value: ConsultaSeguimentoPergunta07Model['PERGUNTA_07_OLHAR_PARA']
): boolean => {
  return isAllNao(value, pergunta07OlharParaEnumValues)
}

export function prunePergunta07(value: ConsultaSeguimentoPergunta07Model): ConsultaSeguimentoPergunta07Model {
  const pruned: ConsultaSeguimentoPergunta07Model = {
    status: value.status,
    resultado: value.resultado,
    PERGUNTA_07_HEADER: value.PERGUNTA_07_HEADER,
    PERGUNTA_07_OLHAR_PARA: value.PERGUNTA_07_OLHAR_PARA,
  }

  const isNotAllNao = !isPergunta07OlharParaAllNao(value.PERGUNTA_07_OLHAR_PARA)
  const isApontaComDedoSim = value.PERGUNTA_07_APONTA_COM_DEDO === SimNaoEnum.SIM

  if (isNotAllNao) {
    pruned.PERGUNTA_07_APONTA_COM_DEDO = value.PERGUNTA_07_APONTA_COM_DEDO
  }

  if (isNotAllNao && isApontaComDedoSim) {
    pruned.PERGUNTA_07_APONTA_POR = value.PERGUNTA_07_APONTA_POR
  }

  return pruned
}

export const conditionToCalculate = (values: ConsultaSeguimentoPergunta07Model): boolean => {
  if (isPergunta07OlharParaAllNao(values.PERGUNTA_07_OLHAR_PARA)) {
    return true
  } else if (hasAnySim(values.PERGUNTA_07_OLHAR_PARA)) {
    if (values.PERGUNTA_07_APONTA_COM_DEDO === SimNaoEnum.SIM) {
      return !isEmpty(values.PERGUNTA_07_APONTA_POR)
    } else {
      return !isEmpty(values.PERGUNTA_07_APONTA_COM_DEDO)
    }
  }
  return false
}

export const calculateResultado = (values: ConsultaSeguimentoPergunta07Model): PassouFalhouEnum => {
  if (isPergunta07OlharParaAllNao(values.PERGUNTA_07_OLHAR_PARA)) {
    return PassouFalhouEnum.FALHOU
  } else if (
    values.PERGUNTA_07_APONTA_COM_DEDO === SimNaoEnum.SIM &&
    values.PERGUNTA_07_APONTA_POR === ConsultaSeguimentoPergunta07ApontaPorEnum.INTERESSE
  ) {
    return PassouFalhouEnum.PASSOU
  } else {
    return PassouFalhouEnum.FALHOU
  }
}
